import { Box, Typography, useTheme, styled, alpha } from '@mui/material';
import React from 'react';

export type InfoGridItem = {
  label: string;
  value: string;
  noWrap?: boolean;
};

type Props = {
  items: InfoGridItem[];
  dark?: boolean;
};

const StyledBox = styled(Box, {
  shouldForwardProp: (props) => props !== 'dark',
})<{ dark?: boolean }>(({ theme, dark }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  border: `1px solid ${dark ? theme.palette.darkBlue.o25 : alpha(theme.palette.common.white, 0.2)}`,
  borderRadius: 4,
  minHeight: '90px',
  '& > :not(:last-of-type)': {
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      right: 0,
      insetBlock: '20%',
      width: '1px',
      backgroundColor: dark ? theme.palette.darkBlue.o25 : alpha(theme.palette.common.white, 0.2),
      display: { xs: 'none', md: 'block' },
    },
  },
}));

const ScenarioInfoGrid: React.FC<Props> = ({ items, dark }) => {
  const theme = useTheme();
  const labelColor = dark ? theme.palette.darkBlue.contrastText : theme.palette.common.white;
  const valueColor = dark ? theme.palette.primary.main : theme.palette.common.white;

  return (
    <StyledBox dark={dark}>
      {items.map(({ label, value, noWrap }, index) => (
        <Box
          key={index}
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: 2,
            textIndent: theme.spacing(4),
            color: valueColor,
          }}>
          <Typography variant="caption" fontSize={12} color={labelColor}>
            {label}
          </Typography>
          <Typography fontWeight={600} noWrap={noWrap}>
            {value}
          </Typography>
        </Box>
      ))}
    </StyledBox>
  );
};

export default ScenarioInfoGrid;
